module.exports = __webpack_public_path__ + "static/media/oops.b8b8f787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oops.png
// module id = 1272
// module chunks = 0